export default {
  data () {
    return {
      detailData: {
        packingMaterialSampleVO: [
          {
            label: '供应商',
            prop: 'supplierName',
          },
          {
            label: '产品名称',
            prop: 'productName',
          },
          {
            label: '配件名称',
            prop: 'accessoryVOList',
            type: 'array',
            propArray: ['name'],
          },
          {
            label: '用途分类',
            prop: 'useClassificationVOList',
            type: 'array',
            propArray: ['classificationName'],
          },
          {
            label: '包材形式',
            prop: 'formName',
            englishLabel: 'form'
          },
          {
            label: '规格',
            prop: 'capacityUnitPriceVOList',
            type: 'array-more',
            propArray: ['capacity', 'price'],
            hide: false,
          },
          {
            label: '预估含税单价（元/个）',
            prop: 'price',
          },
          {
            label: '材质',
            prop: 'material',
          },
          {
            label: '是否有专利',
            prop: 'havePatent',
            type: 'whether',
          },
          {
            label: '生产周期(天)',
            prop: 'productionCycle',
          },
          {
            label: '正式订单的最低起订量(个)',
            prop: 'minNum',
          },
          {
            label: '是否做过大货生产',
            prop: 'haveMassProduction',
            type: 'whether',
          },
          {
            label: '已使用品牌',
            prop: 'brandsUsed',
            hide: false,
          },
          {
            label: '开发进度',
            prop: 'developmentProgress',
            hide: false,
          },
          {
            label: '样品的发货时间(天)',
            prop: 'deliveryTime',
          },
          {
            label: '是否被水羊启用过',
            prop: 'shuiyangEnable',
            type: 'whether',
          },
          {
            label: '采购仓库是否有实物',
            prop: 'companyHave',
            type: 'whether',
          },
          {
            label: '实物存放位置',
            prop: 'storageLocation',
          },
        ],
        odmSampleVO: [
          {
            label: '供应商',
            prop: 'supplierName',
          },
          {
            label: '产品名称',
            prop: 'productName',
          },
          {
            label: '产品类别',
            prop: 'productTypeName',
          },
          {
            label: '产品品类',
            prop: 'productCategoryName',
          },
          {
            label: '产品功效',
            prop: 'odmProductEfficacyVOList',
            type: 'array',
            propArray: ['productEfficacyName'],
          },
          {
            label: '适合肤质',
            prop: 'odmSuitableSkinVOList',
            type: 'array',
            propArray: ['suitableSkinName'],
          },
          {
            label: '产品主打功效',
            prop: 'mainEfficacye',
          },
          {
            label: '产品核心宣称或背书',
            prop: 'endorsement',
          },
          {
            label: '是否有专利',
            prop: 'havePatent',
            type: 'whether',
          },
          {
            label: '预估含税单价（元/个）',
            prop: 'price',
          },
          {
            label: '生产周期(天)',
            prop: 'productionCycle',
          },
          {
            label: '是否做过大货生产',
            prop: 'haveMassProduction',
            type: 'whether',
          },
          {
            label: '已使用品牌',
            prop: 'brandsUsed',
          },
          {
            label: '开发进度',
            prop: 'developmentProgress',
          },
          {
            label: '样品的发货时间(天)',
            prop: 'deliveryTime',
          },
          {
            label: '是否被水羊启用过',
            prop: 'shuiyangEnable',
            type: 'whether',
          },
          {
            label: '采购仓库是否有实物',
            prop: 'companyHave',
            type: 'whether',
          },
          {
            label: '实物存放位置',
            prop: 'storageLocation',
          },
        ],
        fabricSampleVO: [
          {
            label: '供应商',
            prop: 'supplierName',
          },
          {
            label: '产品名称',
            prop: 'productName',
          },
          {
            label: '生产产地',
            prop: 'productionCountryName',
          },
          {
            label: '膜布类型',
            prop: 'fabricTypeName',
          },
          {
            label: '膜布分类',
            prop: 'fabricCategoryName',
          },
          {
            label: '膜布重量（g）',
            prop: 'weight',
          },
          {
            label: '膜布材质',
            prop: 'materialQuality',
          },
          {
            label: '膜布特点',
            prop: 'feature',
          },
          {
            label: '日产能（片）',
            prop: 'dailyCapacity',
          },
          {
            label: '建议吸液量（ml）',
            prop: 'suggestVolume',
          },
          {
            label: '可视化实验',
            prop: 'visualizationExperiment',
          },
          {
            label: '是否可印图案',
            prop: 'printablePattern',
            type: 'whether',
          },
          {
            label: '是否可压实物',
            prop: 'compressibleObject',
            type: 'whether',
          },
          {
            label: '是否有专利',
            prop: 'havePatent',
            type: 'whether',
          },
          {
            label: '预估含税单价（元/片）',
            prop: 'price',
          },
          {
            label: '生产周期(天)',
            prop: 'productionCycle',
          },
          {
            label: '正式订单的最低起订量（张）',
            prop: 'minNum',
          },
          {
            label: '是否做过大货生产',
            prop: 'haveMassProduction',
            type: 'whether',
          },
          {
            label: '已使用品牌',
            prop: 'brandsUsed',
          },
          {
            label: '开发进度',
            prop: 'developmentProgress',
          },
          {
            label: '样品的发货时间(天)',
            prop: 'deliveryTime',
          },
          {
            label: '是否被水羊启用过',
            prop: 'shuiyangEnable',
            type: 'whether',
          },
          {
            label: '采购仓库是否有实物',
            prop: 'companyHave',
            type: 'whether',
          },
          {
            label: '实物存放位置',
            prop: 'storageLocation',
          },
        ],
        rawMaterialSampleVO: [
          {
            label: '供应商',
            prop: 'supplierName',
          },
          {
            label: '产品名称',
            prop: 'productName',
          },
          {
            label: '中文INCI名称',
            prop: 'chineseInciName',
          },
          {
            label: '英文INCI名称',
            prop: 'englishInciName',
          },
          {
            label: 'CAS#',
            prop: 'cas',
          },
          {
            label: 'EC#',
            prop: 'ec',
          },
          {
            label: '是否为自己生产',
            prop: 'whetherSelfProduction',
            type: 'whether',
          },
          {
            label: '是否进口',
            prop: 'whetherImport',
            type: 'whether',
          },
          {
            label: '是否国内有售卖',
            prop: 'whetherInternalSale',
            type: 'whether',
          },
          {
            label: '生产厂家',
            prop: 'manufacturer',
          },
          {
            label: '生产产地',
            prop: 'productionCountryName',
          },
          {
            label: '原料分类',
            prop: 'rawMaterialCategory',
          },
          {
            label: '原料功效',
            prop: 'rawMaterialEfficacy',
          },
          {
            label: '原料功能',
            prop: 'rawMaterialFunction',
          },
          {
            label: '外观形态',
            prop: 'appearance',
          },
          {
            label: '建议添加量',
            prop: 'recommendedAddition',
          },
          {
            label: '最高使用量',
            prop: 'maximumUsage',
          },
          {
            label: '使用说明',
            prop: 'instructions',
          },
          {
            label: '包装规格（kg）',
            prop: 'packageSpecification',
          },
          {
            label: '保质期（月）',
            prop: 'qualityPeriod',
          },
          {
            label: '储存条件',
            prop: 'storageConditionsName',
          },
          {
            label: '是否有专利',
            prop: 'havePatent',
            type: 'whether',
          },
          {
            label: '预估含税单价（元/kg）',
            prop: 'price',
          },
          {
            label: '采购周期 （天）',
            prop: 'purchasingCycle',
          },
          {
            label: '正式订单的最低起订量（kg）',
            prop: 'minNum',
          },
          {
            label: '样品的发货时间(天)',
            prop: 'deliveryTime',
          },
          {
            label: '是否被水羊启用过',
            prop: 'shuiyangEnable',
            type: 'whether',
          },
          {
            label: '采购仓库是否有实物',
            prop: 'companyHave',
            type: 'whether',
          },
          {
            label: '实物存放位置',
            prop: 'storageLocation',
          },
        ],
        giftMaterialSampleVO: [
          {
            label: '供应商',
            prop: 'supplierName',
          },
          {
            label: '产品名称',
            prop: 'productName',
          },
          {
            label: '产品类别',
            prop: 'productTypeName',
          },
          {
            label: '产品品类',
            prop: 'productCategoryName',
          },
          {
            label: '材质',
            prop: 'material',
          },
          {
            label: '尺寸',
            prop: 'size',
          },
          {
            label: '工艺',
            prop: 'craft',
          },
          {
            label: '是否有专利',
            prop: 'havePatent',
            type: 'whether',
          },
          {
            label: '样品的打样时间(天)',
            prop: 'proofingTime',
          },
          {
            label: '样品的大货时间(天)',
            prop: 'deliveryTime',
          },
          {
            label: '正式订单的最低起订量(个)',
            prop: 'minNum',
          },
          {
            label: '预估含税单价（元/个）',
            prop: 'price',
          },
          {
            label: '是否为我司生产过此样品的大货',
            prop: 'haveMassProduction',
            type: 'whether',
          },
          {
            label: '已使用品牌',
            prop: 'brandsUsed',
          },
          {
            label: '开发进度',
            prop: 'developmentProgress',
          },
          {
            label: '采购仓库是否有实物',
            prop: 'companyHave',
            type: 'whether',
          },
          {
            label: '实物存放位置',
            prop: 'storageLocation',
          },
        ],
      }
    }
  },
  methods: {
    // 包材
    getpackingMaterialSampleVO (VO, sampleVO, result) {
      // 图片及容量
      this.detailsInfo = {
        title: sampleVO.productName,
        mainImage: sampleVO.mainImage,
        capacityName: this.sampleVODetail.find(item => item.type === VO).unit,
        capacityUnit: sampleVO.capacityUnit,
        list: sampleVO.capacityUnitPriceVOList.reduce((prev, cur) => {
          prev.push({
            capacity: cur.capacity,
            num: 0,
            specificationId: cur.id,
          });
          return prev;
        }, []),
      };
      const {sideImageList,structureImageList, mainImage} = sampleVO
      const sideImage= sideImageList ? sideImageList : []
      const structureImage= structureImageList ? structureImageList : []
      this.carouselImages = [mainImage, ...sideImage, ...structureImage ]
      this.commonFunction(VO, sampleVO, result);

      // 转换数组
      this.data
        .filter(item => item.type === 'array-more')
        .map(el => {
          el.value = sampleVO[el.prop].map(m => {
            m.unit = sampleVO.capacityUnit;
            return m;
          });
        });
    },
    // odm
    getodmSampleVO (VO, sampleVO, result) {
      this.carouselImages = []
      // 图片及容量
      this.detailsInfo = {
        title: sampleVO.productName,
        mainImage: sampleVO.mainImage,
        capacityName: this.sampleVODetail.find(item => item.type === VO).unit,
        capacityUnit: sampleVO.capacityUnit,
        list: [{
          num: 0,
        }]
      };
      this.commonFunction(VO, sampleVO, result);
    },
    // 赠品
    getgiftMaterialSampleVO (VO, sampleVO, result) {
      // 图片及容量
      this.detailsInfo = {
        title: sampleVO.productName,
        mainImage: sampleVO.mainImage,
        capacityName: this.sampleVODetail.find(item => item.type === VO).unit,
        capacityUnit: sampleVO.capacityUnit,
        list: [{
          num: 0,
        }]
      };
      this.commonFunction(VO, sampleVO, result);
    },
    // 膜布
    getfabricSampleVO (VO, sampleVO, result) {
      if (sampleVO.detailImages && sampleVO.detailImages.length > 0) {
        this.carouselImages = [
          sampleVO.mainImage,
          ...sampleVO.detailImages
        ]
      } else {
        this.carouselImages = []
      }
      // 图片及容量
      this.detailsInfo = {
        title: sampleVO.productName,
        mainImage: sampleVO.mainImage,
        capacityName: this.sampleVODetail.find(item => item.type === VO).unit || '',
        capacityUnit: sampleVO.capacityUnit,
        list: [{
          num: 0,
        }]
      };
      this.commonFunction(VO, sampleVO, result);
    },
    // 原料
    getrawMaterialSampleVO (VO, sampleVO, result) {
      this.detailsInfo = {
        title: sampleVO.productName,
        capacityName: this.sampleVODetail.find(item => item.type === VO).unit,
        list: [{
          num: 0,
        }],
        fileList: sampleVO.sampleAttachmentVOs
      };
      this.commonFunction(VO, sampleVO, result);
    },
    getCheckDetail () {
      return new Promise((resolve, reject) => {
        this.$http.sampleApply.getById(this.row.id)
          .then(result => {
            resolve({ success: true, data: result.data.sampleCheckVO || {} })
          })
          .catch(err => {
            reject(0);
            this.$message.error(err.msg);
          });
      })
    },
    async commonFunction (VO, sampleVO) {
      const { data } = await this.getCheckDetail();
      const { companyHave, storageLocation } = data;
      this.$set(sampleVO, 'companyHave', companyHave)
      this.$set(sampleVO, 'storageLocation', storageLocation)
      // 详细信息
      this.data = this.detailData[VO].map(item => {
        item.value = sampleVO[item.prop];
        return item;
      });

      // 最高使用量为空校验
      const maximumUsage = this.data.find(item => item.prop === 'maximumUsage');
      if (maximumUsage && maximumUsage.value) {
        maximumUsage.value = `≤ ${maximumUsage.value}%`
      }
      // 包材形式
      const formType = this.data.find(item => item.prop === 'formName');
      if (formType && formType.value) {
        formType.englishValue = sampleVO.form;
      }
      
      // 转换YES/NO->是否
      this.data
        .filter(item => item.type === 'whether')
        .map(el => {
          el.value = el.value === 'YES' ? '是' : '否';
          return el;
        });
      // 转换数组(配件，用途，容量单位)
      this.data
        .filter(item => item.type === 'array')
        .map(el => {
          el.value = sampleVO[el.prop].map(m => m[el.propArray[0]]).join('，');
        });
      // 包材形式-其它，彩妆
      if(this.data.find(item => item.englishLabel === 'form')) {
        if(['PRINT_COLOR_BOX', 'SOFT_PACKAGE', 'AUXILIARY_PRODUCTS'].includes(this.data.find(item => item.englishLabel === 'form').englishValue)) {
          this.data.find(item => item.prop === 'price').value = this.data.find(item => item.prop === 'capacityUnitPriceVOList').value[0].price;
          this.data.find(item => item.prop === 'capacityUnitPriceVOList').value = [];
        }
      }
    },
    // form内容显示隐藏
    formValueChange () {
      // if (this.VO === 'packingMaterialSampleVO') {
      //   console.log(['OTHER', 'PRINT_COLOR_BOX'].includes(sampleVO.form))
      //   if (['OTHER', 'PRINT_COLOR_BOX'].includes(sampleVO.form)) {
      //     this.detailData[this.VO].find(item => item.prop === 'capacityUnitPriceVOList').hide = true;
      //   } else {
      //     this.detailData[this.VO].find(item => item.prop === 'capacityUnitPriceVOList').hide = false;
      //   }
      // }
    },
    addShopCartFunc (params) {
      this.shopCartLoading = true;
      this.$http.sampleApply
        .batchCreateToShoppingCart(params)
        .then(async () => {
          await this.getShoppingCartList();
          this.$confirm('成功加入购物车!', '提示', {
            confirmButtonText: '去索样',
            cancelButtonText: '关闭',
            type: 'success',
            distinguishCancelAndClose: true
          }).then(() => {
            this.getSample();
          }).catch(err => {
            if(err === 'close') {
              return;
            }
            const name = '寻样申请';
            const paramName = 'warehouse-sample-manage/sample-application';
            this.$store.dispatch('tagsView/jumpAndClosePage', {
              close: {
                name: this.$route.meta.title,
                href: this.$route.path,
              },
              open: {
                name: name,
                href: `/${paramName}`,
              },
            });
            this.$router.push({
              name: paramName,
            });
          });
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
           this.shopCartLoading = false;
        });
    },
    // 获取购物车列表
    getShoppingCartList () {
      return new Promise((resolve, reject) => {
        this.$http.shoppingCart
          .getShoppingCartList()
          .then(result => {
            // 更新购物车数量
            this.$store.commit('addSampleToCart/setShoppingCartNum', result.data.length);
            resolve();
          })
          .catch(err => {
            this.$message.error(err.msg);
            reject();
          })
      })
    },
    // 立即索样
    getSample () {
      const pageName = '我的购物车';
      const pageUrl = `cml-shopping-cart`;
      this.$store.dispatch('tagsView/clearPage', '');
      this.$store.dispatch('tagsView/changeHeaderMenusList', {
        name: pageName,
        href: `/${pageUrl}`,
      });
      this.$router.push({
        name: pageUrl,
      });
    },
  }
}